(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="header"]';
  var WRAPPER_SELECTOR = '.header-grom';
  var SOLID_CLASS = 'header-grom--solid';
  var SPACER_SELECTOR = '.header-grom__spacer';

  var SOLID_AT = 250;
  var CLEAR_AT = 200;

  var instances = {};

  function HeaderState(container) {
    this.wrapper = container.querySelector(WRAPPER_SELECTOR);
    if (!this.wrapper) return;

    this.spacer = container.querySelector(SPACER_SELECTOR);
    this.solid = false;
    this.ticking = false;

    this.onScroll = this.requestUpdate.bind(this);
    this.onResize = this.onViewportChange.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });

    if (this.spacer && window.ResizeObserver) {
      this.observer = new ResizeObserver(this.syncSpacer.bind(this));
      this.observer.observe(this.wrapper);
    }

    this.syncSpacer();
    this.update();
  }

  HeaderState.prototype.onViewportChange = function () {
    this.syncSpacer();
    this.requestUpdate();
  };

  HeaderState.prototype.syncSpacer = function () {
    if (!this.spacer) return;
    this.spacer.style.height = this.wrapper.offsetHeight + 'px';
  };

  HeaderState.prototype.requestUpdate = function () {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(
      function () {
        this.ticking = false;
        this.update();
      }.bind(this)
    );
  };

  HeaderState.prototype.update = function () {
    var y = window.scrollY || window.pageYOffset || 0;
    var solid = this.solid ? y > CLEAR_AT : y > SOLID_AT;
    if (solid === this.solid) return;

    this.solid = solid;
    this.wrapper.classList.toggle(SOLID_CLASS, solid);
  };

  HeaderState.prototype.unload = function () {
    if (!this.wrapper) return;
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.observer) this.observer.disconnect();
    if (this.spacer) this.spacer.style.height = '';
    this.wrapper.classList.remove(SOLID_CLASS);
  };

  function load(container) {
    if (!container) return;
    var id = container.getAttribute('data-section-id');
    if (!id || instances[id]) return;
    instances[id] = new HeaderState(container);
  }

  function unload(id) {
    if (!instances[id]) return;
    instances[id].unload();
    delete instances[id];
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    load(event.target.querySelector(SECTION_SELECTOR));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) unload(section.getAttribute('data-section-id'));
  });
})();
